'use strict';

export default {
  home: {
    title: 'Home',
    meta: {
      description: 'Homepage description',
    },
  },

  notFound: {
    title: 'Not Found',
    meta: {
      description: 'This page was not found.',
      noIndex: true,
    },
  },

  terms: {
    title: 'Terms',
    meta: {
      description: 'Terms page description',
      noIndex: true,
    },
  },
};



// WEBPACK FOOTER //
// ./client/models/meta.js